<template>
  <section class="d-flex p-0 m-0 contactsection">
    <b-container class="py-5 text-left">
      <h2 class="pb-1">Get in touch</h2>
      <b-row>
        <b-col>
          <div v-if="submitStatus === 'SUCCESS'">
            <b-alert variant="success" show>
              <h4>Thanks!</h4>
              <p>Your request has been received. We'll be in touch soon.</p>
            </b-alert>
          </div>
          <div v-else-if="submitStatus === 'ERROR'">
            <b-alert variant="danger" show>Looks like there was an issue submitting your request. Please try again.</b-alert>
          </div>
          <div v-else>
            <p>Complete the form and we'll get back to you as soon as possible.</p>
          </div>
          <div class="py-3" v-if="submitStatus === 'PENDING'">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
          <div v-else>
            <b-form v-if="submitStatus !== 'SUCCESS'" @submit="checkForm">
              <b-form-row>
                <b-col cols="12" lg="6">
                  <b-form-group
                      :label="firstName.label"
                      :label-for="firstName.id"
                      :state="firstName.state"
                      :aria-required="firstName.required"
                      :invalid-feedback="invalidNameFeedback"
                      :validated="firstName.state"
                      label-size="sm"
                      label-sr-only
                  >
                    <b-form-input
                        @change="checkFname"
                        v-model="firstName.value"
                        :type="firstName.type"
                        :id="firstName.id"
                        :placeholder="firstName.label"
                        :state="firstName.state"
                        required
                        trim
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                      :label="lastName.label"
                      :label-for="lastName.id"
                      :state="lastName.state"
                      :aria-required="lastName.required"
                      :invalid-feedback="invalidNameFeedback"
                      :validated="lastName.state"
                      label-size="sm"
                      label-sr-only
                  >
                    <b-form-input
                        @change="checkLname"
                        v-model="lastName.value"
                        :type="lastName.type"
                        :id="lastName.id"
                        :placeholder="lastName.label"
                        :state="lastName.state"
                        required
                        trim
                    />
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group
                      :label="companyName.label"
                      :label-for="companyName.id"
                      :state="companyName.state"
                      :aria-required="companyName.required"
                      :invalid-feedback="invalidCompanyFeedback"
                      :validated="companyName.state"
                      label-size="sm"
                      label-sr-only
                  >
                    <b-form-input
                        @change="checkCompany"
                        :type="companyName.type"
                        :id="companyName.id"
                        :placeholder="companyName.label"
                        :state="companyName.state"
                        v-model="companyName.value"
                        required
                        trim
                    />
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group
                      :label="emailAddress.label"
                      :label-for="emailAddress.id"
                      :state="emailAddress.state"
                      :invalid-feedback="invalidEmailFeedback"
                      :aria-required="emailAddress.required"
                      :validated="emailAddress.state"
                      label-size="sm"
                      label-sr-only
                  >
                    <b-form-input
                        @change="checkEmail"
                        v-model="emailAddress.value"
                        :type="emailAddress.type"
                        :id="emailAddress.id"
                        :placeholder="emailAddress.label"
                        :state="emailAddress.state"
                        required
                        trim
                    />
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group
                      :label="phoneNumber.label"
                      :label-for="phoneNumber.id"
                      :state="phoneNumber.state"
                      :aria-required="phoneNumber.required"
                      :validated="phoneNumber.state"
                      label-size="sm"
                      label-sr-only
                  >
                    <b-form-input
                        v-model="phoneNumber.value"
                        :type="phoneNumber.type"
                        :id="phoneNumber.id"
                        :placeholder="phoneNumber.label"
                        :state="phoneNumber.state"
                        trim
                    />
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group
                      :label="comment.label"
                      :label-for="comment.id"
                      :state="comment.state"
                      :aria-required="comment.required"
                      :invalid-feedback="invalidCommentFeedback"
                      :validated="comment.state"
                      label-size="sm"
                      label-sr-only
                  >
                    <b-form-textarea
                        @keydown="checkComment"
                        v-model="comment.value"
                        :type="comment.type"
                        :id="comment.id"
                        :placeholder="comment.label"
                        :state="comment.state"
                        rows="3"
                        max-rows="30"
                        required
                    />
                    <p><small>Character limit: {{maxComment}}</small></p>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-button type="submit" variant="accent" size="lg">Submit</b-button>
            </b-form>
          </div>
          <recaptcha ref="recaptcha" @verify="submitForm"></recaptcha>
        </b-col>
        <b-col cols="12" lg="6" class="justify-content-center">
          <b-img-lazy offset="500" blank-color="primary" :src="require('@/assets/van.jpg')" fluid class="p-4 my-5 van"></b-img-lazy>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import axios from "axios";
import Recaptcha from "@/components/sections/Recaptcha";

export default {

  name: "contact",
  components: {Recaptcha},
  data() {
    return {
      sitekey: process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY,
      submitted: false,
      submitStatus: "",
      token: "",
      emailAddress: {
        label: "Email address*",
        id: "email-address",
        type: "email",
        value: "",
        required: true,
        state: null
      },
      companyName: {
        label: "Company name*",
        id: "company-name",
        type: "text",
        value: "",
        required: true,
        state: null
      },
      firstName: {
        label: "First name*",
        id: "first-name",
        type: "text",
        value: "",
        required: true,
        state: null
      },
      lastName: {
        label: "Last name*",
        id: "last-name",
        type: "text",
        value: "",
        required: true,
        state: null
      },
      phoneNumber: {
        label: "Phone number",
        id: "phone-number",
        type: "tel",
        value: "",
        required: true,
        state: null
      },
      comment: {
        label: "Comment*",
        id: "comment",
        type: "textarea",
        value: "",
        required: true,
        state: null,
        maxSize: 500,
      }
    }
  },
  methods: {
    validEmail(email) {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    checkEmail() {
      this.emailAddress.state = this.validEmail(this.emailAddress.value);
    },
    checkFname() {
      this.firstName.state = this.firstName.value.length > 0;
    },
    checkLname() {
      this.lastName.state = this.lastName.value.length > 0;
    },
    checkCompany() {
      this.companyName.state = this.companyName.value.length > 0;
    },
    checkComment(evt) {
      this.comment.state = this.comment.value.length < this.comment.maxSize;
      if (!this.comment.state) {
        if (evt.key !== "Backspace" && evt.key !== "Delete") {
          evt.preventDefault();
        }
      }
    },
    checkForm(e) {
      e.preventDefault();
      this.submitStatus = "PENDING";
      this.$refs.recaptcha.execute();
    },
    submitForm(response) {
      this.token = response;
      let data = this.formData;

      axios.post(process.env.VUE_APP_API_URL + '/contact', data)
          .then(
              () => this.submitStatus = "SUCCESS"
          )
          .catch(
              () => {
                // @TODO log this error
                this.submitted = false;
                this.submitStatus = "ERROR";
              }
          );
      this.submitted = true;
    }
  },
  computed: {
    formData: function () {
      return {
        token: this.token,
        email_address: this.emailAddress.value,
        company_name: this.companyName.value,
        first_name: this.firstName.value,
        last_name: this.lastName.value,
        phone_number: this.phoneNumber.value,
        comment: this.comment.value.substr(0, (this.comment.maxSize - 1))
      }
    },
    invalidEmailFeedback: function () {
      if (!this.emailAddress.state) {
        return "Please enter a valid email";
      }
      return '';
    },
    invalidCommentFeedback: function () {
      if (!this.comment.state) {
        return "Your comment is too long.";
      }
      return '';
    },
    invalidNameFeedback: function () {
      if (!this.lastName.state || !this.firstName.state) {
        return "Please provide your name"
      }
      return ''
    },
    invalidCompanyFeedback: function () {
      if (!this.lastName.state || !this.firstName.state) {
        return "Please provide your company name"
      }
      return ''
    },
    maxComment: function () {
      return this.comment.maxSize - this.comment.value.length;
    }
  }
}
</script>

<style lang="scss">
  @import '@/styles/custom.scss';

  .contactsection {
    background: url('~@/assets/honeycomb-left.png') no-repeat bottom left;
    background-color: $gray-100;
    border-top: 3px solid $primary;
  }
</style>
